import { Controller } from "@hotwired/stimulus"
import { createConsumer } from "@rails/actioncable"

export default class extends Controller {
  static values = { batchId: Number }
  static targets = ["progressBar", "itemsGrid"]

  connect() {
    if (!this.batchIdValue) return

    this.subscription = createConsumer().subscriptions.create(
      { channel: "BatchProgressChannel", batch_id: this.batchIdValue },
      {
        received: (data) => this.handleMessage(data)
      }
    )
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }

  handleMessage(data) {
    switch (data.type) {
      case "item_updated":
      case "item_rated":
        this.updateProgress(data.progress)
        break
      case "batch_status":
        if (["review", "completed", "failed"].includes(data.status)) {
          window.location.reload()
        }
        break
    }
  }

  updateProgress(progress) {
    if (!progress) return

    if (this.hasProgressBarTarget) {
      const pct = progress.total > 0
        ? Math.round((progress.completed / progress.total) * 100)
        : 0
      this.progressBarTarget.style.width = `${pct}%`
    }
  }
}
